import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function LoggedOut() {
  const location = useLocation();
  const isUaePassUser = location.search.includes("uae=true") ? true : false;
  useEffect(() => {
    const returnToApp = `${window.location.origin}/`;
    const uaePassLogoutBase = import.meta.env.VITE_UAE_PASS_LOGOUT_URL;

    const url = isUaePassUser
      ? `${uaePassLogoutBase}?redirect_uri=${encodeURIComponent(returnToApp)}`
      : returnToApp;

    window.location.replace(url);
  }, [isUaePassUser, location.key, location.search, location]);

  return null;
}
